<ng-container *transloco="let t">
  @if (hasPriceDiscount()) {
    <span class="previous-price">{{ price() | currencyFormat }}</span>
    <span class="current-price">{{ priceDiscount() | currencyFormat }}</span>
  } @else {
    <span class="current-price">{{ price() | currencyFormat }}</span>
  }
</ng-container>
